module.exports = __webpack_public_path__ + "img/telecom.d491d09e.png";